<div class="logo-container"
     [class.clickable]="clickable"
     (click)="onClick()">

  <!-- Logo Icon (optional) -->
  @if (showIcon) {
    <img
      [src]="ASSETS_CONSTANTS.ICONS.LOGO"
      alt="{{ environment.applicationName }} logo"
      class="logo-icon"
      [style.width.px]="32"
      [style.height.px]="32"
      [style.border-radius]="'6px'"
      [style.margin-right.px]="32 / 3"
    />
  }

  <!-- Logo Text -->
  @if (showText) {
    <span class="logo-text">
      <span class="logo">{{ environment.applicationName }}</span>
    </span>
  }

</div>
